export default __webpack_public_path__ + "static/media/manulife-glyph.98c14c1b.svg";